module.exports = __webpack_public_path__ + "img/filter2.c7ee3ab1.png";